import React, {useLayoutEffect, useMemo} from 'react';
import { useDispatch } from 'react-redux';
import { AuthContext } from './context';
import Nav from './nav.component';
import axios from 'axios';


export default function RootStack() {

    const dispatch = useDispatch();  //Assign dispatch so we can use it...

    const authContext = useMemo(() => ({  //useMemo react hook, for speeding up execution
      signOut: async () => { 
          localStorage.removeItem('token');
          localStorage.removeItem('firstName');
          localStorage.removeItem('lastName');
          localStorage.removeItem('username');
          localStorage.removeItem('userid');
          localStorage.removeItem('isLoggedIn');
          console.log('🚚 Logout complete, cleared localStorage... ');
          dispatch({ type: 'LOGOUT' });
      }, 
    }), [dispatch]);

    useLayoutEffect(() => { //With useEffectLayout ~ This will run before the return() <Nav /> component completes. 

        const fetchLogin = () => {
            let userid = null;
            let token = null;
            let username = null;
            let firstName = null;
            let lastName = null;
            let isLoggedIn = null;

            try {
                userid = localStorage.getItem('userid');
                username = localStorage.getItem('username');
                token = localStorage.getItem('token');
                firstName = localStorage.getItem('firstName');
                lastName = localStorage.getItem('lastName');
                isLoggedIn = localStorage.getItem('isLoggedIn');
            
                if (isLoggedIn){  //Post LoginRecord
                    axios.post('/person/createLoginRecord', {"userid": userid, "device": "w"}, { headers: { Authorization: token } })  //Post to LoginRecord upon successful login
                    .then((resLoginRecord) => {
                        console.log('{***} LoginRecord Posted: ', resLoginRecord.data);
                    }).catch (err => {
                        console.log('{***} Error posting LoginRecord: ', err);
                    });
                }
            } catch(error) {
                console.log('{RootStack} Existing Login localStorage.getItem/getUsername error: ', error);
            }
            dispatch({ type: 'RETRIEVE_TOKEN', userid: userid, username: username, token: token, firstName: firstName, lastName: lastName, isLoggedIn: isLoggedIn });
        }
        fetchLogin();
    }, [dispatch]);

    return (
        <>
            <AuthContext.Provider value={authContext}>
                <Nav />
            </AuthContext.Provider>
        </>
      );
}
